// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.full-width-table {
    width: 100%;
    border-spacing: 0 20px;
}

.full-width-table td {
    width: 20%;
    padding: 10px 8px;
    /* Add padding for better readability */
}

@media screen and (max-width: 768px) {
    /* Adjust the breakpoint as needed */
    .table-container {
        overflow-x: scroll;
    }
}

.hierarchyConatiner {
    background-color: white;
}

div:has(.hierarchyConatiner) {
    background: white;
    padding-bottom: 2rem;
}

@media screen and(max-width:900px) {
    div:has(.hierarchyConatiner) {
        /* padding-bottom: 5rem; */
    }
}

.hierarchyColumn {
    box-shadow: 2px 2px 10px 2px #ACB4BA4D;
    padding: 0px 10px;
    border-radius: 30px;
    margin-top: 80px;
    /* display: flex;
    justify-content: space-between;
    align-items: center; */
    min-height: 62px;
}

.HierarchyHead {
    /* display: flex ;
    align-items: center;
    justify-content: space-between; */
    padding: 1rem 0rem 1rem 1rem !important;
    font-weight: 500 !important;
    color: #737D86 !important;
}

.hierarchyOrder {
    margin-left: 100%;

}

.hierarchyConfig {
    color: #191E31;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10%;
}

.LevelOrder {
    margin-left: 50px;
}

@media screen and (max-width:800px) {
    .hierarchyColumn {
        overflow-x: scroll;

    }



    .HierarchyHead {
        justify-content: space-between !important;
    }

    .hierarchyOrder {
        margin-left: unset !important;
        padding-left: 5px;
    }

    .hierarchyConfig {
        margin-left: unset !important;
    }

}

@media screen and (max-width:900px) {
    .hierarchyOrder {
        margin-left: unset !important;
        padding-left: 5px;
    }

    .hierarchyConfig {
        margin-left: unset !important;
    }

    .LevelOrder {
        margin-left: unset !important;
    }

    .hierarchyHidden {
        display: none !important;
    }

}

.hierarchyHidden {
    visibility: hidden;
}

.HierarchyTask {
    display: "flex";
    align-items: center;
    justify-content: space-between;
}

.Hierarchy-right-side {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 55%;
    position: absolute;
    right: 10px;
    top: 7px;
}

@media screen and (max-width:1200px)and (min-width:1000px) {
    .Hierarchy-right-side {
        width: 65%;
    }
}

@media screen and (max-width:1000px)and (min-width:900px) {
    .Hierarchy-right-side {
        width: 75%;
    }
}

@media screen and (max-width:900px)and (min-width:800px) {
    .Hierarchy-right-side {
        width: 83%;
    }
}

@media screen and (max-width:800px) {
    .Hierarchy-right-side {
        overflow-x: scroll;
        overflow-y: hidden;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/pages/Hierarchy/Hierarchy.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,uCAAuC;AAC3C;;AAEA;IACI,oCAAoC;IACpC;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,sCAAsC;IACtC,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB;;0BAEsB;IACtB,gBAAgB;AACpB;;AAEA;IACI;;qCAEiC;IACjC,uCAAuC;IACvC,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;;AAErB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,kBAAkB;;IAEtB;;;;IAIA;QACI,yCAAyC;IAC7C;;IAEA;QACI,6BAA6B;QAC7B,iBAAiB;IACrB;;IAEA;QACI,6BAA6B;IACjC;;AAEJ;;AAEA;IACI;QACI,6BAA6B;QAC7B,iBAAiB;IACrB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,wBAAwB;IAC5B;;AAEJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,kBAAkB;IACtB;AACJ","sourcesContent":[".full-width-table {\n    width: 100%;\n    border-spacing: 0 20px;\n}\n\n.full-width-table td {\n    width: 20%;\n    padding: 10px 8px;\n    /* Add padding for better readability */\n}\n\n@media screen and (max-width: 768px) {\n    /* Adjust the breakpoint as needed */\n    .table-container {\n        overflow-x: scroll;\n    }\n}\n\n.hierarchyConatiner {\n    background-color: white;\n}\n\ndiv:has(.hierarchyConatiner) {\n    background: white;\n    padding-bottom: 2rem;\n}\n\n@media screen and(max-width:900px) {\n    div:has(.hierarchyConatiner) {\n        /* padding-bottom: 5rem; */\n    }\n}\n\n.hierarchyColumn {\n    box-shadow: 2px 2px 10px 2px #ACB4BA4D;\n    padding: 0px 10px;\n    border-radius: 30px;\n    margin-top: 80px;\n    /* display: flex;\n    justify-content: space-between;\n    align-items: center; */\n    min-height: 62px;\n}\n\n.HierarchyHead {\n    /* display: flex ;\n    align-items: center;\n    justify-content: space-between; */\n    padding: 1rem 0rem 1rem 1rem !important;\n    font-weight: 500 !important;\n    color: #737D86 !important;\n}\n\n.hierarchyOrder {\n    margin-left: 100%;\n\n}\n\n.hierarchyConfig {\n    color: #191E31;\n    font-weight: 600;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-left: 10%;\n}\n\n.LevelOrder {\n    margin-left: 50px;\n}\n\n@media screen and (max-width:800px) {\n    .hierarchyColumn {\n        overflow-x: scroll;\n\n    }\n\n\n\n    .HierarchyHead {\n        justify-content: space-between !important;\n    }\n\n    .hierarchyOrder {\n        margin-left: unset !important;\n        padding-left: 5px;\n    }\n\n    .hierarchyConfig {\n        margin-left: unset !important;\n    }\n\n}\n\n@media screen and (max-width:900px) {\n    .hierarchyOrder {\n        margin-left: unset !important;\n        padding-left: 5px;\n    }\n\n    .hierarchyConfig {\n        margin-left: unset !important;\n    }\n\n    .LevelOrder {\n        margin-left: unset !important;\n    }\n\n    .hierarchyHidden {\n        display: none !important;\n    }\n\n}\n\n.hierarchyHidden {\n    visibility: hidden;\n}\n\n.HierarchyTask {\n    display: \"flex\";\n    align-items: center;\n    justify-content: space-between;\n}\n\n.Hierarchy-right-side {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 55%;\n    position: absolute;\n    right: 10px;\n    top: 7px;\n}\n\n@media screen and (max-width:1200px)and (min-width:1000px) {\n    .Hierarchy-right-side {\n        width: 65%;\n    }\n}\n\n@media screen and (max-width:1000px)and (min-width:900px) {\n    .Hierarchy-right-side {\n        width: 75%;\n    }\n}\n\n@media screen and (max-width:900px)and (min-width:800px) {\n    .Hierarchy-right-side {\n        width: 83%;\n    }\n}\n\n@media screen and (max-width:800px) {\n    .Hierarchy-right-side {\n        overflow-x: scroll;\n        overflow-y: hidden;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
